import React from 'react';
export function StorySection() {
  return <section className="py-8 md:py-12 border-b border-gray-200" data-id="element-197">
      <h2 className="text-xl md:text-3xl font-bold text-center mb-6 md:mb-8" data-id="element-198">
        The Morning That Changed Everything
      </h2>
      <div className="flex flex-col md:flex-row gap-6 md:gap-8 items-center mb-8 md:mb-10" data-id="element-199">
        <div className="w-full md:w-1/2" data-id="element-200">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gDTEG5QuV8T6jF4RezuEab/pasted-image.jpg" alt="Veteran enjoying coffee by the window" className="w-full h-auto rounded-lg shadow-lg" data-id="element-201" />
        </div>
        <div className="w-full md:w-1/2 mt-4 md:mt-0" data-id="element-202">
          <p className="text-base md:text-lg mb-3 md:mb-4" data-id="element-203">
            Robert Martinez, 47, was going through his late Army buddy's
            belongings when he found something interesting tucked in an old ammo
            box...
          </p>
          <p className="text-base md:text-lg mb-3 md:mb-4" data-id="element-204">
            Handwritten notes about "warming spices for battlefield
            circulation."
          </p>
          <p className="text-sm md:text-lg italic border-l-4 border-gray-300 pl-3 md:pl-4 py-1 md:py-2" data-id="element-205">
            His buddy had written: "Cayenne pepper in hot water every morning -
            keeps the blood moving when it's cold as hell."
          </p>
        </div>
      </div>
      <h3 className="text-lg md:text-2xl font-bold text-center mb-3 md:mb-4" data-id="element-206">
        What Robert Discovered Next Shocked Him
      </h3>
    </section>;
}